import axios from 'axios';

export const createLifewayConsultant = async (data: any) =>
  axios.post(`${process.env.REACT_APP_LIFEWAY_API_URL}/consultant/create`, data).then((response) => response.data);
